<eze-navbar></eze-navbar>

<br />

<div class="container">
	<div *ngIf="eventData && billboard">
		<h1>{{ eventData.name }}</h1>

		<div>Next update in: {{ countdown }} seconds</div>

		<br />

		<div class="row text-center">
			<div class="col-xs-6">
				<div class="card">
					<div class="next-group">
						{{ billboard.color }}
					</div>
					<h2>Next Color Belt Group</h2>
				</div>
			</div>
			<div class="col-xs-6">
				<div class="card">
					<div class="next-group">
						{{ billboard.black }}
					</div>
					<h2>Next Black Belt Group</h2>
				</div>
			</div>
		</div>

		<br />
		<br />

		<div *ngFor="let ring of billboard.rings">
			<div class="ring text-center">
				<h2 class="ring-name">Ring {{ ring.name }}</h2>
				<div class="row" *ngIf="ring.groups; else noGroups">
					<div class="col-xs-6" *ngFor="let group of ring.groups">
						<div class="ring card">
							<div class="ring-group">
								{{ group.name }}
							</div>
							<div *ngIf="bracketLink(group.name)">
								<a
									class="btn btn-primary view-bracket-button"
									[href]="bracketLink(group.name)"
									target="_blank"
								>
									View Bracket
								</a>
							</div>
							<div *ngFor="let athlete of group.athletes">
								{{ athlete }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<br />
		<br />

		<div>
			<img
				class="img-responsive"
				[src]="eventData.postcard"
				style="display: inline;"
				[alt]="eventData.name"
			/>
		</div>
	</div>
</div>

<ng-template #noGroups>
	<div>
		No groups assigned to this ring.
	</div>
</ng-template>
